module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "unreceived"
    }
  }, [_c('h3', [_vm._v("Terima")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.kontras), function(kontra) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.kontrasChecked),
        expression: "kontrasChecked"
      }],
      attrs: {
        "type": "checkbox",
        "id": (kontra.id)
      },
      domProps: {
        "value": (kontra.id),
        "checked": Array.isArray(_vm.kontrasChecked) ? _vm._i(_vm.kontrasChecked, (kontra.id)) > -1 : (_vm.kontrasChecked)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.kontrasChecked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = (kontra.id),
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.kontrasChecked = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.kontrasChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.kontrasChecked = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('label', {
      attrs: {
        "for": (kontra.id)
      }
    }, [_vm._v("\n                    " + _vm._s(kontra.invoices[0].packaging_list.markingcode) + "\n                ")])]), _vm._v(" "), _c('td', [_c('ul', _vm._l((kontra.invoices), function(invoice, index) {
      return _c('li', [_vm._v("\n                    " + _vm._s(invoice.invoiceid) + "\n                    ")])
    }), 0)])])
  }), 0)]), _vm._v(" "), (_vm.kontrasChecked.length > 0) ? _c('div', {
    staticClass: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.setReceived
    }
  }, [_vm._v("Terima")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Marking")]), _vm._v(" "), _c('th', [_vm._v("Invoice")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5943563b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kontra/KontraReceived.vue
// module id = 1814
// module chunks = 1